import React from 'react';
import Register from '../components/Login-Register/Register';
const RegisterPage = () => {
  return (
    <div>
      <Register />
    </div>
  );
};

export default RegisterPage;
